export const ui_version = '2.2.2'
export const work_modes = ['On-site', 'Remote', 'Hybrid ']
export const e_types = ['Part time', 'Full time']
export const prospect_type = ['Lead', 'Enquiry', 'Installation']
export const prospect_status = ['Completed', 'Cancelled']
export const prospect_urgency = ['Hot', 'Warm', 'Cool']
export const prospect_possibility = ['Hot', 'Warm', 'Cool', 'Chill']
export const salesApp_user_access = ['slur_lead_write', 'slur_eqr_write', 'slur_install_write', 'slur_gdwn_write']
export const lead_status_color = ['#ED007E', '#ED007E', '#005EDA', '#037355', '#DE5500', '#D60000']
export const resource_titles =
    [
        'water-problems-client', 'water-test-source', 'water-test-color', 'water-test-odor', 'work-sites',
        'purifier-installation-mode', 'category-of-pipes', 'vessel-installation-positions', 'purifier-components',
        'vessel-components', 'vessel-materials'
    ]
export const payment_methods = ['CASH', 'BANK', 'CHEQUE']
export const site_categories = ['DOMESTIC', 'COMMERCIAL', 'INDUSTRIAL']
export const team_list_color_code =
    [
        '#8e24aa', '#039de5', '#d50000', '#33b679', '#f69826', '#93bd0b', '#f4511e', '#7986cb',
        '#e67c73', '#0b8043', '#bd0b93', '#0baebd', '#6f03fc', '#fc036b'
    ]

export const controllerCalenderTypes = [
    {
        id: 'lead',
        name: 'Lead App',
        read_access: ['slcr_leList_read', 'slcr_leList_write'],
        event_access: ['slur_lead_write'],
        status_list: [
            { id: 'le_follow_up_initial', name: 'Follow-up : Initial', color_code: '#0baebd' },
            { id: 'le_follow_up_pending', name: 'Follow-up : Pending', color_code: '#0baebd' },
            { id: 'le_follow_up_closed', name: 'Follow-up : Closed', color_code: '#8e24aa' },
            { id: 'le_completed', name: 'Completed', color_code: '#0b8043' },
            { id: 'le_cancelled', name: 'Cancelled', color_code: '#d50000' },
        ]
    },
    {
        id: 'enquiry',
        name: 'Enquiry App',
        read_access: ['slcr_eqList_read', 'slcr_eqList_write'],
        event_access: ['slur_eqr_write'],
        status_list: [
            { id: 'eq_follow_up_initial', name: 'Follow-up : Initial', color_code: '#0baebd' },
            { id: 'eq_recall_pending', name: 'Follow-up : Pending', color_code: '#0baebd' },
            { id: 'eq_recall_closed', name: 'Follow-up : Closed', color_code: '#8e24aa' },
            { id: 'eq_on_scheduled', name: 'On Scheduled', color_code: '#fc036b' },
            { id: 'eq_enquiry_visit', name: 'Area visited', color_code: '#f69826' },
            { id: 'eq_on_wait_list', name: 'Wait list : Pending', color_code: '#6f03fc' },
            { id: 'eq_wait_list_closed', name: 'Wait list : Closed', color_code: '#93bd0b' },
            { id: 'eq_completed', name: 'Completed', color_code: '#0b8043' },
            { id: 'eq_cancelled', name: 'Cancelled', color_code: '#d50000' },
        ]
    },
    {
        id: 'installation',
        name: 'Installation App',
        read_access: ['slcr_inList_read', 'slcr_inList_write'],
        event_access: ['slur_install_write'],
        status_list: [
            { id: 'ins_follow_up_initial', name: 'Follow-up : Initial', color_code: '#0baebd' },
            { id: 'ins_recall_pending', name: 'Follow-up : Pending', color_code: '#0baebd' },
            { id: 'ins_recall_closed', name: 'Follow-up : Closed', color_code: '#8e24aa' },
            { id: 'ins_on_scheduled', name: 'On Scheduled', color_code: '#fc036b' },
            { id: 'ins_completed', name: 'Completed', color_code: '#0b8043' },
            { id: 'ins_cancelled', name: 'Cancelled', color_code: '#d50000' },
        ]
    },
]

export const leadStatusCodeList = [
    { id: 'le_registration', name: 'Registration', visibility: ['les_list'], dateField: ['reg_date'], color_code: '#bd8d0bff' },
    { id: 'le_out_of_bucket', name: 'Out of Bucket', visibility: ['les_list'], dateField: ['reg_date'], color_code: '#bd8d0bff' },
    { id: 'le_follow_up_initial', name: 'Follow-up : Initial', visibility: ['les_list'], dateField: null, color_code: '#0bbd23ff' },
    { id: 'le_follow_up_pending', name: 'Follow-up : Pending', visibility: ['calender', 'les_list'], dateField: ['follow_up_assign_to'], color_code: '#0baebd' },
    { id: 'le_follow_up_closed', name: 'Follow-up : Closed', visibility: ['calender', 'les_list'], dateField: ['follow_up_attended_at'], color_code: '#8e24aa' },
    { id: 'le_completed', name: 'Completed', visibility: ['calender', 'les_list'], dateField: ['work_closed_at'], color_code: '#0b8043' },
    { id: 'le_cancelled', name: 'Cancelled', visibility: ['calender', 'les_list'], dateField: ['work_closed_at'], color_code: '#d50000' },
]

export const enquiryStatusCodeList = [
    { id: 'eq_registration', name: 'Registration', visibility: ['les_list'], dateField: ['reg_date'], color_code: '#bd8d0bff' },
    { id: 'eq_out_of_bucket', name: 'Out of Bucket', visibility: ['les_list'], dateField: ['convert_date', 'reg_date'], color_code: '#bd8d0bff' },
    { id: 'eq_follow_up_initial', name: 'Follow-up : Initial', visibility: ['les_list'], dateField: null, color_code: '#0baebd' },
    { id: 'eq_recall_pending', name: 'Follow-up : Pending', visibility: ['calender', 'les_list'], dateField: ['follow_up_assign_to'], color_code: '#0baebd' },
    { id: 'eq_recall_closed', name: 'Follow-up : Closed', visibility: ['calender', 'les_list'], dateField: ['follow_up_attended_at'], color_code: '#8e24aa' },
    { id: 'eq_on_scheduled', name: 'On Scheduled', visibility: ['calender', 'les_list'], dateField: ['scheduled_at_st', 'scheduled_at_et'], color_code: '#fc036b' },
    { id: 'eq_enquiry_visit', name: 'Area visited', visibility: ['calender', 'les_list'], dateField: ['visit_in_time'], color_code: '#f69826' },
    { id: 'eq_on_wait_list', name: 'Wait list : Pending', visibility: ['calender', 'les_list'], dateField: ['wait_list_assign_to'], color_code: '#6f03fc' },
    { id: 'eq_wait_list_closed', name: 'Wait list : Closed', visibility: ['calender', 'les_list'], dateField: ['wait_list_attended_at'], color_code: '#93bd0b' },
    { id: 'eq_completed', name: 'Completed', visibility: ['calender', 'les_list'], dateField: ['work_closed_at'], color_code: '#0b8043' },
    { id: 'eq_cancelled', name: 'Cancelled', visibility: ['calender', 'les_list'], dateField: ['work_closed_at'], color_code: '#d50000' },
]

export const installationStatusCodeList = [
    { id: 'ins_out_of_bucket', name: 'Out of Bucket', visibility: ['les_list'], dateField: null, color_code: '#bd8d0bff' },
    { id: 'ins_follow_up_initial', name: 'Follow-up : Initial', visibility: ['les_list'], dateField: null, color_code: '#0baebd' },
    { id: 'ins_recall_pending', name: 'Follow-up : Pending', visibility: ['calender', 'les_list'], dateField: ['follow_up_assign_to'], color_code: '#0baebd' },
    { id: 'ins_recall_closed', name: 'Follow-up : Closed', visibility: ['calender', 'les_list'], dateField: ['follow_up_attended_at'], color_code: '#8e24aa' },
    { id: 'ins_on_scheduled', name: 'On Scheduled', visibility: ['calender', 'les_list'], dateField: ['scheduled_at_st', 'scheduled_at_et'], color_code: '#fc036b' },
    { id: 'ins_completed', name: 'Completed', visibility: ['calender', 'les_list'], dateField: ['visit_in_time'], tHead: 'Closed Date', color_code: '#0b8043' },
    { id: 'ins_cancelled', name: 'Cancelled', visibility: ['calender', 'les_list'], dateField: ['work_closed_at'], tHead: 'Closed Date', color_code: '#d50000' },
]

export const les_type_list = [
    { option: 'Lead', value: 'lead', origins: ['slcr_leList_write', 'slcr_leList_read'] },
    { option: 'Enquiry', value: 'enquiry', origins: ['slcr_eqList_write', 'slcr_eqList_read'] },
    { option: 'Installation', value: 'installation', origins: ['slcr_inList_write', 'slcr_inList_read'] }
]







